import React, { useContext } from "react";
import Avatar from "../../../elements/Avatar";
import Button from "../../../elements/Button";
import Dialog from "../../../elements/Dialog";
import { UserContext } from "../../../UserContext";
import { postData } from "../../../utils/api";
import { useMembers, useMembersToast } from "../MembersContext";

const ResetAuth = ({ member }) => {
  const { currentUser } = useContext(UserContext);
  const { dispatch } = useMembers();
  const { dispatchToast } = useMembersToast();

  async function resetAuth() {
    try {
      const response = await postData(`/${currentUser.organizationId}/approve_two_factor_reset`, {
        user_id: member.id,
      });
      dispatch({ type: "approve_reset_auth", payload: { member: response.user } });
      dispatchToast({
        type: "success_toast",
        payload: response.notice || "Two-factor authentication successfully reset.",
      });
    } catch (error) {
      dispatchToast({ type: "error_toast" });
    }
  }

  return (
    <Dialog
      trigger={
        <Button variant="secondary" utilityClasses="br--pill ph--12">
          Reset Two-Factor Auth
        </Button>
      }
      title="Reset Two-Factor Authentication"
      description="Reset this member's two-factor authentication so they can set it up again."
      confirm={
        <Button
          onClick={resetAuth}
          utilityClasses="ph--8 br--pill lh--tight flex--item-grow1"
          data-cy="reset-two-factor-auth-confirmation-button"
        >
          Confirm
        </Button>
      }
      cancel={
        <Button variant="secondary" utilityClasses="ph--24 br--pill lh--tight">
          Cancel
        </Button>
      }
    >
      <div className="display--flex flex--items-center gap--16 pa--24 br--8 bg--dialog-input">
        <Avatar initials={member.initials} size="lg" />
        <div>
          <h3 className="fs--18 fw--500">{member.name}</h3>
          <span className="fs--12">{member.email}</span>
        </div>
      </div>
    </Dialog>
  );
};

export default ResetAuth;
